module.exports = __webpack_public_path__ + "img/rincontravel.5a484099.png";